import { rankingData } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          人气榜单
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-12 max-w-[600px] mx-auto">
          国产91视频热门内容排行榜，看看大家都在追什么
        </p>

        <div className="max-w-[800px] mx-auto">
          {rankingData.map((item, index) => (
            <div
              key={item.id}
              className="group flex items-center gap-4 p-4 border-b border-background-200/60 last:border-b-0 cursor-pointer transition-colors hover:bg-background-100/70 rounded-lg"
            >
              <div className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-lg font-heading font-extrabold text-lg ${
                index < 3
                  ? 'bg-primary-100 text-primary-600'
                  : 'bg-background-100 text-foreground-400'
              }`}>
                {index + 1}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-2 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
              </div>
              <div className="flex-shrink-0 flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-fire-line text-accent-500 text-sm"></i>
                </span>
                <span className="text-sm font-bold text-accent-600 font-heading">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}